/**
 * Registers non-mandatory Samsung remote keys so they fire as `keydown` events.
 * Directional, Enter and Back keys are provided by Tizen without registration.
 *
 * Safe to call on non-Tizen platforms — the tvinputdevice API simply won't exist.
 */
export function registerTizenRemoteKeys(): void {
  const tizen = (window as any).tizen;
  if (!tizen?.tvinputdevice) return;

  const keys = ['MediaPlay', 'MediaPause', 'MediaPlayPause', 'MediaStop',
                 'MediaFastForward', 'MediaRewind',
                 '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

  keys.forEach((key) => {
    try {
      tizen.tvinputdevice.registerKey(key);
    } catch {
      // Key may already be registered or not supported on this model
    }
  });
}

export type MediaKeyAction = 'play' | 'pause' | 'playPause' | 'stop' | 'fastForward' | 'rewind';

export function getMediaKeyAction(event: KeyboardEvent): MediaKeyAction | null {
  const key = event.key || '';
  const code = (event as any).keyCode || (event as any).which || 0;
  if (key === 'MediaPlay' || code === 415) return 'play';
  if (key === 'MediaPause' || code === 19) return 'pause';
  if (key === 'MediaPlayPause' || code === 179 || code === 10252) return 'playPause';
  if (key === 'MediaStop' || code === 413) return 'stop';
  if (key === 'MediaFastForward' || code === 417) return 'fastForward';
  if (key === 'MediaRewind' || code === 412) return 'rewind';
  return null;
}
